import React, { useState, useEffect } from 'react';
import { SignIn, SignedIn, SignedOut, useAuth } from '@clerk/clerk-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@/components/theme-provider';
import { ClerkProvider } from '@/components/layout/clerk-provider';
import { PermissionProvider } from '@/lib/contexts/permission-context';
import { ErrorBoundary } from '@/components/error-boundary';
import { useTheme } from '@/lib/hooks/use-theme';
import AdminDashboard from './components/AdminDashboard';
import LogoDark from '@/img/logo-dark.png';
import LogoLight from '@/img/logo-light.png';


if (!import.meta.env.VITE_CLERK_PUBLISHABLE_KEY) {
  throw new Error('Missing Clerk Publishable Key');
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function SignInPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 gap-8">
      <img
        src={LogoDark}
        alt="Logo"
        className="h-20 w-auto"
      />
      <SignIn />
    </div>
  );
}

function AppContent() {
  const { isSignedIn, isLoaded } = useAuth();


  React.useEffect(() => {
  }, [isSignedIn, isLoaded]);

  if (!isLoaded) {
    return null;
  }


  return (
    <>
      {isSignedIn ? (
        <>
          
          <PermissionProvider>
            <AdminDashboard />
          </PermissionProvider>
        </>
      ) : (
        <>
          
          <SignInPage />
        </>
      )}
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: 'hsl(var(--background))',
            color: 'hsl(var(--foreground))',
            border: '1px solid hsl(var(--border))',
          },
        }}
      />
    </>
  );
}

export default function App() {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
    <ErrorBoundary>
      <ThemeProvider>
        <ClerkProvider forceTheme="light">
          <QueryClientProvider client={queryClient}>
            <BrowserRouter
              future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
              }}
            >
              <AppContent />
            </BrowserRouter>
          </QueryClientProvider>
        </ClerkProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}